"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RelayLazyLogger;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _js = require("@adeira/js");

var _logGroup = _interopRequireDefault(require("./logGroup"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var logEventsMap = new Map();

function createGroupMessage(operationName, operationKind) {
  return "[Relay".concat(operationKind != null ? " ".concat(operationKind) : '', "] ").concat(operationName !== null && operationName !== void 0 ? operationName : '');
} // Very similar to the eager one except it waits for the response and prints all the information at once.


function RelayLazyLogger(logEvent) {
  if (!(process.env.NODE_ENV !== "production") || !(0, _js.isBrowser)()) {
    return;
  }

  if (logEvent.name === 'network.start') {
    logEventsMap.set(logEvent.transactionID, {
      operationKind: logEvent.params.operationKind,
      operationName: logEvent.params.name,
      variables: logEvent.variables
    });
  } else if (logEvent.name === 'network.next') {
    // TODO: log subscriptions as they arrive
    var savedEvent = logEventsMap.get(logEvent.transactionID);

    if (savedEvent) {
      logEventsMap.set(logEvent.transactionID, _objectSpread(_objectSpread({}, savedEvent), {}, {
        response: logEvent.response
      }));
    }
  } else if (logEvent.name === 'network.complete' || logEvent.name === 'network.unsubscribe') {
    var _savedEvent = logEventsMap.get(logEvent.transactionID);

    (0, _logGroup.default)(createGroupMessage(_savedEvent === null || _savedEvent === void 0 ? void 0 : _savedEvent.operationName, _savedEvent === null || _savedEvent === void 0 ? void 0 : _savedEvent.operationKind), function () {
      console.log("Variables: %o", _savedEvent === null || _savedEvent === void 0 ? void 0 : _savedEvent.variables);
      console.log("Response: %o", _savedEvent === null || _savedEvent === void 0 ? void 0 : _savedEvent.response);
    });
  } else if (logEvent.name === 'network.error') {
    var _savedEvent2 = logEventsMap.get(logEvent.transactionID);

    (0, _logGroup.default)(createGroupMessage(_savedEvent2 === null || _savedEvent2 === void 0 ? void 0 : _savedEvent2.operationName, _savedEvent2 === null || _savedEvent2 === void 0 ? void 0 : _savedEvent2.operationKind), function () {
      console.error(logEvent.error);
    }, undefined, 'color:red');
  } else if (logEvent.name === 'entrypoint.root.consume' || logEvent.name === 'network.info' || logEvent.name === 'queryresource.fetch' || logEvent.name === 'queryresource.retain' || logEvent.name === 'store.gc' || logEvent.name === 'store.notify.complete' || logEvent.name === 'store.notify.start' || logEvent.name === 'store.publish' || logEvent.name === 'store.restore' || logEvent.name === 'store.snapshot') {// noop (explicitly so we know we covered everything)
  } else {
    checkEmpty(logEvent);
  }
}

function checkEmpty(logEvent) {
  console.error('Relay: cannot decide how to log event: %s', JSON.stringify(logEvent));
}